import { render, staticRenderFns } from "./SafeSetting.vue?vue&type=template&id=2c64637a&scoped=true"
import script from "./SafeSetting.vue?vue&type=script&lang=js"
export * from "./SafeSetting.vue?vue&type=script&lang=js"
import style0 from "./SafeSetting.vue?vue&type=style&index=0&id=2c64637a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64637a",
  null
  
)

export default component.exports